import { Injectable } from '@angular/core';
import { KYMW7003Model } from '../kymw7003.model';
import { FeatureRequestInfo } from '../vo/feature-request-info.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// リクエスト構造
export interface GetFeatureRequestStatusListRequest {
  search: {
    FeatureRequestList: {
      condition: {
        UserType: string;
        PayeeSupplierCode: string;
        AssociatedCompanyId: string;
      };
    };
  }
}
// レスポンス構造
interface GetFeatureRequestStatusListResponse {
  FeatureRequestStatusGoodsList: {
    OrderCode: string,
    CatalogIdName: string,
    MediumType: string,
    MediumName: string,
    FeatureCode: string,
    FeatureName: string,
    SelectionFlag: number,
    Remarks: string,
   }[];
}

/**
 * 特集商品提案状況一覧取得サービス
 * @export GetFeatureRequestStatusListService
 * @class GetFeatureRequestStatusListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureRequestStatusListService extends PlessJsonResponderSub<GetFeatureRequestStatusListResponse> {

  model: KYMW7003Model;
  private calbak: () => void;
  private requestData: GetFeatureRequestStatusListRequest;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureRequestStatusListService
   */
  private getBody(): PlessRequest {
    // リクエストを設定
    this.requestData = {
      search: {
        FeatureRequestList: {
          condition:{
            UserType: this.model.userType,
            PayeeSupplierCode: this.model.payeeSupplierCode,
            AssociatedCompanyId: this.model.associatedCompanyId,
          }
        }
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureRequestStatusListService
   */
  execute(model: KYMW7003Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getFeatureRequestStatusList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureRequestStatusListService
   */
  success(data: GetFeatureRequestStatusListResponse) {
    this.model.featureRequestList = data.FeatureRequestStatusGoodsList.map(_ => 
      new FeatureRequestInfo(
        _.OrderCode,
        _.CatalogIdName,
        _.MediumType,
        _.MediumName,
        _.FeatureCode,
        _.FeatureName,
        Number(_.SelectionFlag),
        _.Remarks,
      )
    );

    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
  
}